import { useLocation, useNavigate } from "react-router-dom";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { Button, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useLoader } from "../../context/LoaderContext";
import {
  createMetaDataGroup,
  getGroupDataEdit,
} from "../../api/metaDataGroupsApi/metaDataGroupsApi";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

interface MetadataGroupsMangementActionProps {
  businessUnitData: any;
}

const MetadataGroupsMangementAction: React.FC<
  MetadataGroupsMangementActionProps
> = ({ businessUnitData }) => {
  const { setLoading } = useLoader();
  const location = useLocation();
  const action = location.state?.action || {};
  const rowData = location.state?.rowData || {};
  const [groupName, setGroupName] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [isActive, setIsActive] = useState(rowData.active ?? true);

  const { showSnackbar } = useSnackbar();
  const [errors, setErrors] = useState<{
    fieldNameError?: string;
  }>({});
  const [, setData] = useState<any>([]);// NOSONAR
  const navigate = useNavigate();
  const validateGroupName = (value: any) => {
    let error = "";
    const alphaNumericRegex = /^[a-zA-Z0-9\s]*$/;
    if (!alphaNumericRegex.test(value)) {
      error = "Please note you can enter Alphanumeric characters only";
    }
    if (value.length > 100) {
      error = "Maximum of 100 characters can be entered.";
    }
    if (!value.trim()) {
      error = "Please enter the Group Name";
    }
    return error;
  };

  const handleGroupNameChange = (e: any) => {
    const value = e.target.value;
    const error = validateGroupName(value);

    setGroupName(value);
    setErrors({ fieldNameError: error });
  };

  useEffect(() => {
    if (action === "Edit") {
      getGroupData();
    }
  }, []);

  const getGroupData = async () => {
    setLoading(true);
    try {
      const param = {
        GroupId: rowData?.groupid,
      };
      const response = await getGroupDataEdit(param);
      if (response) {
        setData(response);
        setGroupName(response[0].groupName);
      } else {
        setGroupName("");
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDialogClose = (confirm: boolean) => {
    try {
      setConfirmDialogOpen(false);
      if (confirm) {
        navigate("/metadataGroupDisplay");
      } else {
        setConfirmDialogOpen(false);
      }
    } catch (error) {
      console.error("Error in handleConfirmDialogClose", error);
    }
  };

  const handelCancel = () => {
    setConfirmDialogOpen(true);
  };

  const handleCreate = async () => {
    setLoading(true);
    try {
      const newErrors: { fieldNameError?: string } = {};
      if (!groupName) {
        newErrors.fieldNameError = "Group Name is required";
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        const newPayload = {
          Active: isActive,
          CreatedBy: Number(LocalStorageUtil.getItem("userId")),
          GroupName: groupName,
          Groupid: rowData.groupid === undefined ? 0 : rowData.groupid,
          LastModifiedDate: rowData.lastModifiedDate,
          UpdatedBy: Number(LocalStorageUtil.getItem("userId")),
        };
        await createMetaDataGroup(newPayload);
        navigate("/metadataGroupDisplay");
        if (action === "Edit") {
          showSnackbar("Metadata Group updated successfully");
        } else {
          showSnackbar("Metadata Group created successfully");
        }
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };
  const handleStatusChange = () => {
    setIsActive((prevIsActive: any) => {
      const updatedStatus = !prevIsActive;
      return updatedStatus;
    });
  };

  return (
    <div>
      {action === "Edit" ? (
        <NavigationBar
          menuTitle="Configuration"
          title="Metadata Management"
          screenTitle="Metadat Groups"
          text="Metadata Group  - Update Metadata Group"
        />
      ) : (
        <NavigationBar
          menuTitle="Configuration"
          title="Metadata Management"
          screenTitle="Metadat Groups"
          text="Metadata Group  - Create Metadata Group"
        />
      )}
      <div style={{ margin: "1em" }}>
        <div
          className="col-sm-5"
          style={{
            width: "97%",
            textAlign: "right",
            margin: "10px",
          }}
        >
          {action === "Edit" && (
            <Tooltip
              title={
                rowData.active
                  ? "Click to make the role inactive"
                  : "Click to make the role active"
              }
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isActive}
                    onChange={handleStatusChange}
                    color="primary"
                    size="small"
                    data-testid="status-checkbox"
                  />
                }
                label={isActive ? "Active" : "In-Active"}
                style={{
                
                  margin: "1px 3px" ,
                  textTransform: "none",
                  fontSize: "11px",
                  color: isActive ? "#154360" : "#7B241C",
                  backgroundColor: isActive ? "#D6EAF8" : "#FADBD8",
                  padding: "3px 6px",
                  borderRadius: "3px",
                  alignItems: "center",
                  height: "2.5em",
                }}
              />
            </Tooltip>
          )}
        </div>

        <h4
          style={{
            color: "var(--aggrid-text-color)",
            margin: "20px",
            fontSize: "12px",
          }}
        >
          {" "}
          Basic Information
        </h4>
        <div className="form-inp col-sm-12">
          <Row style={{ margin: "10px" }}>
            <Col>
              <Form>
                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Group controlId="formGroupName">
                      <Form.Label
                        className="input-labels"
                        style={{
                          color: "var(--aggrid-text-color)",
                          fontSize: "11px",
                        }}
                      >
                        Group Name<span className="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter the Group Name"
                        name="groupName"
                        isInvalid={!!errors.fieldNameError}
                        value={groupName}
                        onChange={handleGroupNameChange}
                        required
                        style={{ fontSize: "11px" }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.fieldNameError}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
        <div
          className="form-group"
          style={{ margin: "20px", fontSize: "11px" }}
        >
          <small
            className="recom-msg guide"
            title="Info"
            style={{ color: "var(--aggrid-text-color)" }}
          >
            <InfoIcon />
            <br />
            1. Please enter Alphabets and Numbers only
            <br />
            (Special Characters are not allowed).
            <br />
            2. Maximum of 100 characters can be entered.
            <br />
            3. Metadata Group cannot be left Blank.
            <br />
            4. Always append the word “Information” at the End..
            <br />
            5. Metadata Group Name should be Unique.
            <br />
            6. Example : File Information
          </small>
        </div>
        <div className="form-inp col-sm-12">
          <Row>
            <Col
              md={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginLeft: "-50px",
              }}
            >
              <Button className="update-button" onClick={handleCreate}>
                {action === "Edit" ? "Update" : "Create"}
              </Button>
              <Button className="cancel-button" onClick={handelCancel}>
                Cancel
              </Button>
            </Col>
          </Row>
        </div>
        <ConfirmDialog
          open={confirmDialogOpen}
          onClose={handleConfirmDialogClose}
          title={`Metadata Group - ${
            action === "Edit" ? "Update" : "Create New"
          }`}
          content="Are you sure you want to Cancel?"
        />
      </div>
    </div>
  );
};

export default MetadataGroupsMangementAction;
